/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Payment_Terms_Monthly_InterestInputs */

const en_clients_payment_terms_monthly_interest = /** @type {(inputs: Clients_Payment_Terms_Monthly_InterestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interest (% per month)`)
};

const pt_br2_clients_payment_terms_monthly_interest = /** @type {(inputs: Clients_Payment_Terms_Monthly_InterestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juros (% ao mês)`)
};

/**
* | output |
* | --- |
* | "Interest (% per month)" |
*
* @param {Clients_Payment_Terms_Monthly_InterestInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_payment_terms_monthly_interest = /** @type {((inputs?: Clients_Payment_Terms_Monthly_InterestInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Payment_Terms_Monthly_InterestInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_payment_terms_monthly_interest(inputs)
	return pt_br2_clients_payment_terms_monthly_interest(inputs)
});